import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import client, { endpoints } from '../api/client';

const CATS = ['All', 'Guide', 'Tutorial', 'Blog', 'Case study'];

export default function Articles() {
  const { user } = useSelector((s) => s.auth);
  const [data, setData] = useState({ articles: [], total: 0 });
  const [cat, setCat] = useState('All');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await client.get(endpoints.articles.list, { params: { category: cat, search, limit: 30 } }); setData(data); }
    finally { setLoading(false); }
  }, [cat, search]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="container community">
      <div className="page-head">
        <div><h1>Articles</h1><p className="muted">Guides, tutorials and updates.</p></div>
        {user && <Link to="/articles/new" className="btn-primary">Write an article</Link>}
      </div>
      <div className="toolbar">
        <div className="seg">{CATS.map((c) => <button key={c} className={cat === c ? 'on' : ''} onClick={() => setCat(c)}>{c}</button>)}</div>
        <form onSubmit={(e) => { e.preventDefault(); load(); }} className="search">
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search articles…" />
          <button className="btn-ghost">Search</button>
        </form>
      </div>
      {loading ? <p className="muted">Loading…</p> : data.articles.length === 0 ? <p className="muted">No articles yet.</p> : (
        <div className="agrid">
          {data.articles.map((a) => (
            <Link key={a.slug} to={`/articles/${a.slug}`} className="acard">
              {a.coverImage ? <img src={a.coverImage} alt="" /> : <div className="acover" />}
              <div className="acard-body">
                {a.category && <span className="cat">{a.category}</span>}
                <h3>{a.title}</h3>
                <p className="muted">{a.excerpt}</p>
                <div className="qfoot"><span className="byline">{a.author?.name}</span><span className="muted">♥ {a.likeCount}</span></div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
